import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Chip from 'atoms/Chip'
import ItemEditDialog from './ItemEditDialog'

export default class ScheduleEditorWeekDay extends Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    onItemAdd: PropTypes.func.isRequired,
    weekDay: PropTypes.number.isRequired,
    addFormTitle: PropTypes.string.isRequired,
    editFormTitle: PropTypes.string.isRequired,
  }

  state = {
    dialogOpen: false
  }

  toggleDialog = () => {
    const { dialogOpen } = this.state
    this.setState({ dialogOpen: !dialogOpen })
  }

  handleSubmit = (items) => {
    const { onItemAdd } = this.props
    onItemAdd(items)
  }

  render() {
    const { addFormTitle, editFormTitle } = this.props
    const { dialogOpen } = this.state
    const { active, weekDay } = this.props
    const day = moment().isoWeekday(weekDay)
    return (
      <Fragment>
        <ItemEditDialog
          open={dialogOpen}
          onClose={this.toggleDialog}
          defaultWeekDay={weekDay}
          onSubmit={this.handleSubmit}
          addFormTitle={addFormTitle}
          editFormTitle={editFormTitle}
        />
        <Chip
          round
          disablePadding
          active={active}
          onClick={this.toggleDialog}
        >
          { day.format('dd') }
        </Chip>
      </Fragment>
    )
  }
}
